const reviewsModSlider = () => {
	let reviewsSlider = $('.reviewsSlider');

	if (reviewsSlider.length > 0) {
		reviewsSlider.each(function (num, elem) {
			elem = $(elem);
			elem.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				dots: true,
				adaptiveHeight: true,
				prevArrow: $('.reviews__prev')[num],
				nextArrow: $('.reviews__next')[num],
			});
		});
	}
};

export default reviewsModSlider;
